import React from "react";
import "./Newfryrightbaner.css";
// import chefimage1 from "https://all-frontend-assets.s3.amazonaws.com/fryright_images/chef+2.webp";
// import food1 from "../../../../assets/images/food2.webp";
const Newfryrightbaner = () => {
  return (
    <div className="FrBaner block-container">
      <div className="container">
        <div className="bannersubblock">
          <span className="bannertextwrapper">
            <h1>
              The Fry <br /> Right SYSTEM
            </h1>
            <div className="bannertitle">
              <h2>
                Superior fried food, <span>everytime.</span>
              </h2>
            </div>
          </span>
          <span className="bannerimagewrapper">
            <img src="https://all-frontend-assets.s3.amazonaws.com/fryright_images/food2.webp" alt="#" className="abimage1 " />
            <img src="https://all-frontend-assets.s3.amazonaws.com/fryright_images/chefrenew.webp" alt="#" className="abimage2" />
          </span>
        </div>
      </div>
    </div>
  );
};

export default Newfryrightbaner;
